import React, {useEffect, useState} from 'react';
import {AppLogo, MatchesMediaQuery} from '@taopix/taopix-design-system';
import {useExperience} from '../Experience/ExperienceProvider';
import {Lang, Localisation} from '@taopix/taopix-core';
import useSettings from '../../Hooks/useSettings';
import {formatOnlineUrl, getUrl} from '../../Utils/Common';

type LogoProps = {} & React.HTMLAttributes<HTMLButtonElement>;

const Logo = ({...props}: LogoProps) => {
  const [logo, setLogo] = useState('');
  const {state: settings} = useSettings();
  const {experience} = useExperience();

  const isDarkMode = MatchesMediaQuery('(prefers-color-scheme: dark)');

  useEffect(() => {
    if (isDarkMode && '' !== settings.logo.imageDark) {
      return setLogo(formatOnlineUrl(settings.logo.imageDark));
    }
    setLogo(formatOnlineUrl(settings.logo.image));
  }, [isDarkMode]);

  // if we have no logo return a fragment
  if ('' === logo) {
    return <></>;
  }

  return (
    <AppLogo
      src={logo}
      alt={'logo'}
      linkUrl={getUrl(experience.SETTINGS.logoLinkUrl.logoLinkUrl)}
      tip={Localisation.getLocaleString(
        Lang.getCode(),
        experience.SETTINGS.logoLinkUrl.logoLinkToolTipText
      )}
      className={props.className}
    />
  );
};

export default Logo;
